import { SidebarItemVM } from 'src/app/components/layout/sidebar/_types/SidebarItemVM';
import { Permissions } from 'src/app/utils/permissions/permissions';

export const getSidebarItems = (corpId: string): SidebarItemVM[] => {
  return [
    {
      path: `/portal/corps/${corpId}/dashboard`,
      title: 'Dashboard',
      type: 'link',
      testId: 'corp-dashboard-link',
      iconFilePath: 'assets/icons/icon-nav-dash.svg',
    },
    {
      path: `/portal/corps/${corpId}/settings`,
      title: 'Settings',
      type: 'link',
      icontype: 'ni-settings-gear-65 text-white',
      testId: 'corp-settings-link',
      permission: Permissions.CAN_READ_CORP_SETTINGS,
    },
  ];
};
